
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  section: 'Bank Transfers',
  title: 'Idempotency',
  toc: true,
  maxTocLevel: 4,
  layout: 'guide',
  description: 'Learn how idempotency and retries improve your integration stability',
  noIndex: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Idempotency and Retries' subtitle={metadata.description} mdxType="Header" />
    <h4 {...{
      "id": "idempotency"
    }}>{`Idempotency`}</h4>
    <p>{`When originating a transfer through `}<inlineCode parentName="p">{`/bank_transfer/create`}</inlineCode>{`, it is important that Plaid can correctly differentiate distinct requests. The required parameter `}<inlineCode parentName="p">{`idempotency_key`}</inlineCode>{` is used, along with the parameters `}<inlineCode parentName="p">{`client_id`}</inlineCode>{`, `}<inlineCode parentName="p">{`amount`}</inlineCode>{`, `}<inlineCode parentName="p">{`account_id`}</inlineCode>{`, `}<inlineCode parentName="p">{`type`}</inlineCode>{`, and `}<inlineCode parentName="p">{`network`}</inlineCode>{`, to establish the uniqueness of a request.`}</p>
    <p>{`Any two requests having the same value for these parameters will be treated as the same request and result in only a single transfer. The second request will simply return the transfer created by the first. Plaid guarantees idempotency between requests for at least 7 days after the request was made. As an added level of safety, you may confirm whether a request generated a new transfer by checking the ID returned from the API against your own database.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`idempotency_key`}</inlineCode>{` alone does not establish uniqueness - this is to support re-use of a single idempotency key across a batch of transfers. For example, debiting a batch of accounts on the first of the month and using the calendar date as your idempotency key, you can be sure to generate separate requests as each transfer targets a different account. The `}<inlineCode parentName="p">{`idempotency_key`}</inlineCode>{` can be used to communicate to Plaid that two similar-looking requests are distinct. For example, in order to originate a transfer for the same amount and account as another transfer, sending a different value for `}<inlineCode parentName="p">{`idempotency_key`}</inlineCode>{` will result in a new transfer.`}</p>
    <h4 {...{
      "id": "retries"
    }}>{`Retries`}</h4>
    <p>{`Although Plaid works to establish a highly reliable service, from time to time the API will be unable to process a request and return an unknown server error (status code 500). In these cases, you should retry the request through the Plaid API only - Plaid ensures that retries with the same parameters (as described in the Idempotency section) will never result in a duplicated transfer. Resubmitting the request through a secondary provider has no such guarantee.`}</p>
    <p>{`It's a good idea when retrying requests to use an exponential backoff strategy, as this avoids exacerbating issues caused by resource exhaustion. Retries, along with idempotency, provide an added level of reliability that requests to move money are correctly received and processed by Plaid.`}</p>
    <Callout warning mdxType="Callout">
      <p>{`A 500 status code returned from `}<inlineCode parentName="p">{`/bank_transfer/create`}</inlineCode>{` is an unknown error. In these cases, Plaid can't guarantee that the request was or was not successful. You should retry the request or reach out directly before taking further action.`}</p>
    </Callout>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "idempotency",
        level: 4,
        title: "Idempotency",
      },
{
        id: "retries",
        level: 4,
        title: "Retries",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
